module.exports = __webpack_public_path__ + "5f429ec5ddfad6ea151ab82056629f0a.png";